import { combineEpics } from 'redux-observable';
import { getSubdomainEpic } from './get-subdomain';
import { querySubdomainEpic } from './query-subdomain';
import { updateSubdomainEpic } from './update-subdomain';
import { getSubdomainForArtistEpic } from './get-subdomain-for-artist';
import { getSubdomainAfterSubscriptionEpic } from './get-subdomain-after-subscription';

const subdomainEpic = combineEpics(
  getSubdomainEpic,
  querySubdomainEpic,
  updateSubdomainEpic,
  getSubdomainForArtistEpic,
  getSubdomainAfterSubscriptionEpic
);

export default subdomainEpic;